<template>
  <div class="container">
       <div id="chartdiv">
 <timechart v-if="loaded" :chartdata="chartdata" :options="options" :chart-id="myID"/>
 </div>
    <p style="font-size:14px" v-if="filterText!=''">{{filterText}}</p>
    <p style="font-size:12px" v-if="showDateRange"> <a href="#daterange" class="card-link">Click here to specify custom Date Range for chart</a><span v-if="(start_date != start_date_min) || (end_date != end_date_max)">. Custom Date Range in effect.  </span> </p>
    <b-form-checkbox size="sm" v-if="showAdjustYaxis" v-model="adjustYaxis" switch @change="adjustY()" >Adjust Y Axis scale for better visibility. {{YaxisText}}</b-form-checkbox>
    <b-form-checkbox size="sm" v-if="showCompare" v-model="adjustCompare" switch @change="toggleCompare()" >{{compare_ctrl_text}}</b-form-checkbox>
  </div>
</template>

<script>
import TimeChart from "./TimeChart.js";
import { API } from "aws-amplify";
import { nextTick } from 'vue';

export default {
  name: "TimeChart2Container",
  components: {
    timechart: TimeChart
  },
  props: ["collection_id", "collection_type", "user", "chart_id", "label", "stacked", "reflines", "instance_num", "targets", "targetValues", "adjustment", "colorScheme", "filter", "filter_prompt", "start_date", "end_date", "start_date_min", "end_date_max", "showDateRange",
          "compare_collection_id", "compare_chart_id", "compare_label", "compare_ctrl_text"],
  data: () => ({
    loaded: false,
    chartdata: null,
    maindata: null,
    newdata: null,
    adjustYaxis: true,
    showAdjustYaxis: false,
    YaxisTag: {},
    YaxisText: '',
    adjustCompare: false,
    showCompare: false,
    baseDatasets: 2,
    myID: "dave3",
    filterText: "Chart loading...",    
    options: {
      bezierCurve : false,
      elements: {
        line: {
          tension: 0
        }
      },
      scales: {
        xAxes: [
          {
            type: "time",
            time: {
              unit: 'day',
                    displayFormats: {
           'millisecond': 'MMM DD',
           'second': 'MMM DD',
           'minute': 'MMM DD',
           'hour': 'MMM DD',
           'day': 'MMM DD',
           'week': 'MMM DD',
           'month': 'MMM DD',
           'quarter': 'MMM DD',
           'year': 'MMM DD'
                    }
                }
          }
        ],
        yAxes: [
          { 
            id: 'y-axis-0',
            stacked: true,
            ticks: {}
          }
        ]
      },
      responsive: true,
      maintainAspectRatio: false,
      gradient: null,
      gradient2: null,
      annotation: {
        annotations: [
          {
            type: 'line',
            mode: 'horizontal',
            scaleID: 'y-axis-0',
            value: 4,
            borderColor: 'black',
            borderWidth: 2,
            label: {
              enabled: true,
              position: "left",
              xAdjust: 400,
              xPadding: 4,
              yPadding: 4,
              cornerRadius: 4,
              content: 'Max'
            }
          },
          {
            type: 'line',
            mode: 'horizontal',
            scaleID: 'y-axis-0',
            value: 4,
            borderColor: 'black',
            borderWidth: 2,
            label: {
              enabled: true,
              position: "left",
              xAdjust: 320,
              xPadding: 4,
              yPadding: 4,
              cornerRadius: 4,
              content: '99%'
            }
          },
          {
            type: 'line',
            mode: 'horizontal',
            scaleID: 'y-axis-0',
            value: 4,
            borderColor: 'black',
            borderWidth: 2,
            label: {
              enabled: true,
              position: "left",
              xAdjust: 240,
              xPadding: 4,
              yPadding: 4,
              cornerRadius: 4,
              content: '95%'
            }
          },
          {
            type: 'line',
            mode: 'horizontal',
            scaleID: 'y-axis-0',
            value: 4,
            borderColor: 'black',
            borderWidth: 2,
            label: {
              enabled: true,
              position: "left",
              xAdjust: 160,
              xPadding: 4,
              yPadding: 4,
              cornerRadius: 4,
              content: '90%'
            }
          },
          {
            type: 'line',
            mode: 'horizontal',
            scaleID: 'y-axis-0',
            value: 4.5,
            borderColor: 'black',
            borderWidth: 2,
            label: {
              enabled: true,
              position: "left",
              xAdjust: 80,
              content: 'Avg',
              xPadding: 4,
              yPadding: 4,
              cornerRadius: 4
            }
          },
          {
            type: 'line',
            mode: 'horizontal',
            scaleID: 'y-axis-0',
            value: 4,
            borderColor: 'black',
            borderWidth: 2,
            label: {
              enabled: true,
              position: "left",
              xAdjust: 0,
              xPadding: 4,
              yPadding: 4,
              cornerRadius: 4,
              content: '50%'
            }  
          }
          
        ]
      }
      

    }
  }),
  async mounted() {
    this.loaded = false;
    
    this.myID = this.chart_id;
    var real_chart_id = this.myID;
    
    //handle special PDB charts
    if (this.myID=="PDB_CPU") {
      real_chart_id="CPUAVGPEAK";
    }
    if (this.myID=="PDB_IOTHRU") {
      real_chart_id="IO_MBS_AVGPEAK";
    }
    if (this.myID=="PDB_IOPS") {
      this.baseDatasets=1;
    }
   
    
    if ((real_chart_id=="IO_MBS_AVGPEAK")&&( (this.adjustment!=undefined) && (this.adjustment*1!=0)&&(this.adjustment*1!=1))) {
      this.myID="IO_MBS_AVGPEAKADJ";
    }
    if ((real_chart_id=="IOPS_AVGPEAK")&&( (this.adjustment!=undefined) && (this.adjustment*1!=0)&&(this.adjustment*1!=1))) {
      this.myID="IOPS_AVGPEAKADJ";
    }
    if ((real_chart_id=="PDB_IOPS")&&( (this.adjustment!=undefined) && (this.adjustment*1!=0)&&(this.adjustment*1!=1))) {
      this.myID="PDB_IOPSADJ";
    }

   // console.log(this.myID, this.collection_id, this.adjustment, this.filter, this.targetValues);

      // console.log("TCC2 filter",this.filter, ( ((this.filter==undefined)||(this.filter=="NaN")||(this.filter*1==0)) || ((this.filter!=undefined)&&(this.filter*1>0)) ) );

// var ctx = document.getElementById('line-chart').getContext("2d")
//     this.gradient = ctx.createLinearGradient(0, 0, 0, 450)
//     this.gradient2 = ctx.createLinearGradient(0, 0, 0, 450)
    // this.gradient = this.$children[0].$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450)
    // this.gradient2 = this.$children[0].$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 450)

    // this.gradient.addColorStop(0, 'rgba(255, 0,0, 0.5)')
    // this.gradient.addColorStop(0.5, 'rgba(255, 0, 0, 0.25)');
    // this.gradient.addColorStop(1, 'rgba(255, 0, 0, 0)');
    
    // this.gradient2.addColorStop(0, 'rgba(0, 231, 255, 0.9)')
    // this.gradient2.addColorStop(0.5, 'rgba(0, 231, 255, 0.25)');
    // this.gradient2.addColorStop(1, 'rgba(0, 231, 255, 0)');
// console.log("stacked",this.stacked)
// console.log("chartid",this.chart_id)
     if (this.stacked=="false") {
       this.options.scales.yAxes[0].stacked = false;
     }  


    try {
      // console.log("TCC2: I am here");
      let sorted = [];
      let total_val = 0;
      let current_val = 0;
      let filterCount = 0;
      let filterTotalItemsChecked = 0;
      

      
      if (this.maindata == null) {
        var new_collection_id = this.collection_id;
        if (this.instance_num === undefined) {
        } else
        {
          new_collection_id = this.collection_id+'-'+this.instance_num;
        }
        var tries = 2;
        var didIfilter=false;
        var useAdjustment=1.0;
        if ( (this.adjustment!=undefined) && (this.adjustment*1!=0) && (this.adjustment*1!=1) ) useAdjustment = (this.adjustment*1);
        while (tries > 0) {
          filterCount = 0;
          filterTotalItemsChecked = 0;
          await API.get("dbcsiAPI", `/dbcsi/${new_collection_id}/${this.collection_type}/${real_chart_id}`)
            .then(response => {
              // console.log("TCC2: I am here3");
              this.maindata = response.data;
              this.newdata = [[], [], [], []];
            // console.log("main data", real_chart_id, this.maindata.length);
            
              if (this.start_date) {
                // console.log("start_date", this.start_date, this.maindata.length, this.maindata[0].x);
                this.maindata = this.maindata.filter((row) => row.x >= this.start_date);
                // console.log("start_date AFTER", this.start_date, this.maindata.length, this.maindata[0].x);
              }
              
              if (this.end_date) {
                // console.log("end_date", this.end_date, this.maindata.length, this.maindata[0].x);
                this.maindata = this.maindata.filter((row) => row.x <= (this.end_date+" 23:59:59") );
                // console.log("end_date AFTER", this.end_date, this.maindata.length, this.maindata[0].x);
              }
              
              for (var ii = 0; ii < this.maindata.length; ii++) {
                 didIfilter=false;
                 filterTotalItemsChecked++;
                // console.log("filter,id",this.filter, this.chart_id, this.adjustment);
                
                //fix data (some chartIDs return data as y not y1)
                if (this.maindata[ii].y!=undefined) this.maindata[ii].y1=this.maindata[ii].y;

                if ( ((this.filter==undefined)||(this.filter=="NaN")||(this.filter*1==0)) || ((this.filter!=undefined)&&(this.filter*1>0)&&(this.maindata[ii].y1*1 < this.filter)) ) {
                  //we are not using a filter or we meet the filter
                
                  
                    this.newdata[0].push({
                      x: this.maindata[ii].x,
                      y: this.maindata[ii].y1/useAdjustment
                    });
                    
                    if ( ((this.filter==undefined)||(this.filter=="NaN")||(this.filter*1==0)) || ((this.filter!=undefined)&&(this.filter*1>0)&&(this.maindata[ii].y2*1 < this.filter)) ) {
                      filterTotalItemsChecked++;
                      this.newdata[1].push({
                        x: this.maindata[ii].x,
                        y: this.maindata[ii].y2/useAdjustment
                      });
                      // console.log("adjusting y2");
                    } else {
                      if (this.maindata[ii].y2!=undefined) {
                        filterTotalItemsChecked++;
                        filterCount++;
                        console.log("filter y2",real_chart_id,this.collection_id, this.maindata[ii].x,this.maindata[ii].y2);
                        didIfilter=true;
                      }  
                    } 
                    
                    // do we even have y3??
                    this.newdata[2].push({
                      x: this.maindata[ii].x,
                      y: this.maindata[ii].y3/useAdjustment
                    });
                    
                    // do we even have y4??
                    this.newdata[3].push({
                      x: this.maindata[ii].x,
                      y: this.maindata[ii].y4/useAdjustment
                    });
                  
                  
                  //calculate statistics
                  if (!didIfilter) {
                    if (this.maindata[ii].y2!=undefined) {
                      if (this.stacked=="false") {
                        current_val=Math.max(Number(this.maindata[ii].y1/useAdjustment),Number(this.maindata[ii].y2/useAdjustment));
                      } else {
                        current_val=Number(this.maindata[ii].y1/useAdjustment)+Number(this.maindata[ii].y2/useAdjustment);
                      } 
                    }  
                    else  {
                      if (this.stacked=="false") {
                        current_val=Math.max(Number(this.maindata[ii].y1/useAdjustment));
                      } else {
                        current_val=Number(this.maindata[ii].y1/useAdjustment);
                      } 
                    }
                    total_val = total_val + current_val;
                    sorted.push(current_val);
                    // console.log("stats",real_chart_id,this.collection_id, this.maindata[ii].x,this.maindata[ii].y1,this.maindata[ii].y2,current_val);
                  }
                } else
                {
                  filterCount++;
                  console.log("filter y",real_chart_id,this.collection_id, this.maindata[ii].x,this.maindata[ii].y1);
                 
                }
              } // for loop across all data
              
              

              tries = 0;
              // console.log(this.newdata[0]);
            })
            .catch(error => {
              console.log("TCC2 Error:", error);
            });
            
      
          tries -= 1;
        }
      }


      this.chartdata = {
        datasets: [
          {
            label: this.label.split(":")[0],
            data: this.newdata[0],
            borderColor: "#ff0000",
            backgroundColor: "rgba(255, 0,0, 0.25)",
            borderWidth: 1,
            pointRadius: 1,
            fill: true
          // borderColor: '#FC2525',
          // pointBackgroundColor: 'white',
          // borderWidth: 1,
          // pointBorderColor: 'white'
          // backgroundColor: this.gradient
          },
          {
            label: this.label.split(":")[1],
            data: this.newdata[1],
            // borderColor: "#3e95cd",
            borderColor: "rgba(0, 0, 255, 1)",
            backgroundColor: "rgba(0, 0, 255, 0.25)",
            // borderColor: "rgba(0, 231, 255, 1)",
            // backgroundColor: "rgba(0, 231, 255, 0.5)",
            borderWidth: 1,
            pointRadius: 1,            
            fill: true
          // borderColor: '#05CBE1',
          // pointBackgroundColor: 'white',
          // pointBorderColor: 'white'
          // borderWidth: 1
          // backgroundColor: this.gradient2

          }
        ]
      };
      
      
      if (this.colorScheme=="adhoc2") {
        this.chartdata.datasets[0].fill = false;
        this.chartdata.datasets[1].borderColor = "#3e95cd";
        this.chartdata.datasets[1].backgroundColor = "#3e95cd";
        this.chartdata.datasets[1].fill = false;
      }
      
      //TODO: if chart is IO_MBS_RW or IO_MBS_RW_MAX, then change backgroundColor
      //            borderColor: "rgba(0, 255, 0, 1)",
      //      backgroundColor: "rgba(0, 255, 0, 0.25)",
      //            borderColor: "rgba(0, 128, 128, 1)",
      //      backgroundColor: "rgba(0, 128, 128, 0.25)",
      if ((real_chart_id=="IO_MBS_RW")||(real_chart_id=="IO_MBS_RW_MAX")||(real_chart_id=="EXADATA3")) {
        this.chartdata.datasets[0].borderColor = "rgba(0, 200, 80, 1)";
        this.chartdata.datasets[0].backgroundColor = "rgba(0, 200, 80, 0.25)";
        this.chartdata.datasets[1].borderColor = "rgba(0, 128, 128, 1)";
        this.chartdata.datasets[1].backgroundColor = "rgba(0, 128, 128, 0.25)";
         
      }
      if ((real_chart_id=="EXADATA2")) {
        this.chartdata.datasets[0].borderColor = "orange";
        this.chartdata.datasets[0].backgroundColor = "orange";
      }
      if ((real_chart_id=="CPUAVGPEAK")||(real_chart_id=="IOPS_AVGPEAK")||(real_chart_id=="IO_MBS_AVGPEAK")) {
        // this.chartdata.datasets[1].borderColor = "brown";
        // this.chartdata.datasets[1].backgroundColor = "tan";
        // 217, 206, 178
        this.chartdata.datasets[1].borderColor = "rgba(194, 183, 155, 1)";
        this.chartdata.datasets[1].backgroundColor = "rgba(194, 183, 155, 0.25)";
         
      }
      if ((real_chart_id=="MEMORY")) {
        //. 64, 185, 230. 33, 237, 234. 67, 222, 121
        this.chartdata.datasets[0].borderColor = "rgba(33, 237, 234, 1)";
        this.chartdata.datasets[0].backgroundColor = "rgba(33, 237, 234, 0.6)";
      }
      
      if ((real_chart_id=="EXADATA")) {
        //. 64, 185, 230. 33, 237, 234. 67, 222, 121
        this.baseDatasets=4;
        this.chartdata.datasets[0].fill = true;
        this.chartdata.datasets[1].fill = false;
        this.chartdata.datasets[1].borderWidth = 2,
        this.chartdata.datasets[2] = {
            label: this.label.split(":")[2],
            data: this.newdata[2],
            borderColor: "rgba(0, 200, 80, 1)",
            backgroundColor: "rgba(0, 200, 80, 0.25)",
            borderWidth: 3,
            pointRadius: 1,            
            fill: false
        };    
        this.chartdata.datasets[3] = {
            label: this.label.split(":")[3],
            data: this.newdata[3],
            borderColor: "rgba(194, 183, 155, 1)",
            backgroundColor: "rgba(194, 183, 155, 0.25)",
            borderWidth: 1,
            pointRadius: 1,            
            fill: true
        };    
       
        // this.chartdata.datasets[1].borderColor = "rgba(0, 128, 128, 1)";
        // this.chartdata.datasets[1].backgroundColor = "rgba(0, 128, 128, 0.25)";
          
          // GREEN
            // borderColor: "rgba(0, 200, 80, 1)",
            // backgroundColor: "rgba(0, 200, 80, 0.25)",
            
          // GREY
            // borderColor: "rgba(194, 183, 155, 1)",
            // backgroundColor: "rgba(194, 183, 155, 0.25)",
          

        
      }



      //calculate statistics
      //sort values
      //calculate median and percentiles
      sorted.sort(function(a, b){return a-b});

      // console.log("chartid",real_chart_id, sorted);
      
      let pctl90 = sorted[Math.min(sorted.length-1, Math.trunc(sorted.length*89.999/100)+1)];
      let pctl95 = sorted[Math.min(sorted.length-1, Math.trunc(sorted.length*95/100)+1)];
      let pctl99 = sorted[Math.min(sorted.length-1, Math.trunc(sorted.length*98.999/100)+1)];
      let pctl50 = sorted[Math.min(sorted.length-1, Math.trunc(sorted.length*49.999/100)+1)];
      let pctlmax = sorted[sorted.length-1];
      let pctlavg = (total_val/sorted.length);
      
      //console.log (total_val);
      
      //update annotations
      let scale=10; // was 0.1
      this.options.annotation.annotations[5].value = pctl50;
      this.options.annotation.annotations[5].label.content = "P50: "+Math.round(pctl50*scale)/scale;
      this.options.annotation.annotations[4].value = pctlavg;
      this.options.annotation.annotations[4].label.content = "Avg: "+Math.round(pctlavg*scale)/scale;
      this.options.annotation.annotations[3].value = pctl90;
      this.options.annotation.annotations[3].label.content = "P90: "+Math.round(pctl90*scale)/scale;
      this.options.annotation.annotations[2].value = pctl95;
      this.options.annotation.annotations[2].label.content = "P95: "+Math.round(pctl95*scale)/scale;
      this.options.annotation.annotations[1].value = pctl99;
      this.options.annotation.annotations[1].label.content = "P99: "+Math.round(pctl99*scale)/scale;
      this.options.annotation.annotations[0].value = pctlmax;
      this.options.annotation.annotations[0].label.content = "Max: "+Math.round(pctlmax*scale)/scale;
      //done

      // should we adjust the Y axis ?
      let maxY = Math.max(Math.round(pctl90*15/10)*10,Math.round(pctlavg*10/10)*10);
      // console.log("scale?",this.collection_id, this.chart_id, real_chart_id,this.adjustment, maxY, pctlmax*1,pctl90*1, pctlavg*1);
      if ( (pctlmax > 20* pctl90) &&  this.adjustYaxis && (maxY > 0) ) {
        // make sure that maxY is > than the targetValues
        var maxYOK = true;
        if (this.targets != undefined) {
        
         let targetArr = this.targets.split(":");
         for (var ii = 0; ii < targetArr.length; ii++) {
          // console.log("targets",maxY,1*this.targetValues.split(":")[ii]);
           if (maxY< 1*this.targetValues.split(":")[ii]) {
             maxYOK=false;
           }
           //console.log(this.options.annotation.annotations[ii].label.content,this.options.annotation.annotations[ii].value);
         }
        }   
        
        if (maxYOK) {
          this.options.scales.yAxes[0].ticks.max = maxY;
          // console.log("max", this.options.scales.yAxes[0].ticks.max);
          this.YaxisTag = this.options.scales.yAxes[0].ticks;
          this.showAdjustYaxis = true;
          this.YaxisText = "The maximum value in the dataset is "+Math.round(pctlmax*scale)/scale +".";
        }  
      }
    
     // console.log(this.reflines);  
     if ((this.reflines==false) || (this.reflines=="false")) {
       // console.log("reflines is false");
       //if targets
       if (this.targets == undefined) {
        // console.log("no targets in TCC2");
         this.options.annotation = {};
       } else
       {
         let targetArr = this.targets.split(":");
         for (var ii = 0; ii < targetArr.length; ii++) {
           this.options.annotation.annotations[ii].label.content=targetArr[ii];
           this.options.annotation.annotations[ii].value=this.targetValues.split(":")[ii];
           //console.log(this.options.annotation.annotations[ii].label.content,this.options.annotation.annotations[ii].value);
         }
         //fix label offsets
         this.options.annotation.annotations[0].label.xAdjust=0;
         this.options.annotation.annotations[1].label.xAdjust=300;
         this.options.annotation.annotations[2].label.xAdjust=400;
         this.options.annotation.annotations[3].label.xAdjust=500;
         this.options.annotation.annotations[4].label.xAdjust=600;
         this.options.annotation.annotations[5].label.xAdjust=700;
        // this.options.annotation.annotations[1].label.xAdjust=100;
        // this.options.annotation.annotations[2].label.xAdjust=200;
        // this.options.annotation.annotations[3].label.xAdjust=300;
        // this.options.annotation.annotations[4].label.xAdjust=400;
        // this.options.annotation.annotations[5].label.xAdjust=500;

         this.options.annotation.annotations[0].label.yAdjust=5;
         this.options.annotation.annotations[1].label.yAdjust=5;
         this.options.annotation.annotations[2].label.yAdjust=5;

         this.options.annotation.annotations[0].borderDash = [5, 15];
         
         // clear out remaining annotations
         this.options.annotation.annotations.splice(targetArr.length,6-targetArr.length);
         
       }   
     }  
     
     //handle case where we only have 1 dataset to chart
     if (this.label.split(":")[1]==undefined) {
       this.baseDatasets=1;
        // delete the 2nd dataset
        this.chartdata.datasets.splice(1,1);
     }

      //handle special PDB charts
      var doMorePDBdata = false;
      if (this.chart_id=="PDB_CPU") {
        real_chart_id="PDB_CPU_USAGE_PER_S";
        doMorePDBdata = true;
        this.baseDatasets=3;
      }
      if (this.chart_id=="PDB_IOTHRU") {
        real_chart_id="PDB_IOMBPS";
        doMorePDBdata = true;
        this.baseDatasets=3;
      }
      if (this.chart_id=="PDB_IOPS") {
        
        this.baseDatasets=1;
        // delete the 2nd dataset
        this.chartdata.datasets.splice(1,1);
      }

        
      if (doMorePDBdata) {
          // console.log(`/dbcsi/${this.collection_id}/${this.collection_type}/${real_chart_id}`);
         
          await API.get("dbcsiAPI", `/dbcsi/${this.collection_id}/${this.collection_type}/${real_chart_id}`)
            .then(response => {
              // console.log("TCC2: I am here3");
              this.maindata = response.data;
              this.newdata = [[], [], []];
              // console.log("compare data", this.maindata.length);

              for (var ii = 0; ii < this.maindata.length; ii++) {
                // console.log("filter,id",this.filter, real_chart_id, this.adjustment);
                
                //fix data (some chartIDs return data as y not y1)
                if (this.maindata[ii].y!=undefined) this.maindata[ii].y1=this.maindata[ii].y;

                if ( ((this.filter==undefined)||(this.filter=="NaN")||(this.filter*1==0)) || ((this.filter!=undefined)&&(this.filter*1>0)&&(this.maindata[ii].y1*1 < this.filter)) ) {
                  //we are not using a filter or we meet the filter
                
                 
                    this.newdata[0].push({
                      x: this.maindata[ii].x,
                      y: this.maindata[ii].y1/useAdjustment
                    });
                    
                    
                  
                
                  
                  //calculate statistics
                  if (this.stacked=="false") {
                    current_val=Math.max(Number(this.maindata[ii].y1/useAdjustment));
                  } else {
                    current_val=Number(this.maindata[ii].y1/useAdjustment);
                  }  
                  total_val = total_val + current_val;
                  sorted.push(current_val);
                } else
                {
                  filterCount++;
                  console.log("filter",real_chart_id);
                }
              }
              

              tries = 0;
              // console.log(this.newdata[0]);
            })
            .catch(error => {
              console.log("TCC2b Error:", error);
            });      
            
            // add to datasets
            this.chartdata.datasets[this.baseDatasets-1] = {
            label: this.label.split(":")[this.baseDatasets-1],
            data: this.newdata[0],
            // borderColor: "rgba(223, 157, 31, 0.9)",
            backgroundColor: "rgba(223, 157, 31, 0.25)",
            borderWidth: 1,
            pointRadius: 1,
            fill: true
          // borderColor: '#FC2525',
          // pointBackgroundColor: 'white',
          // borderWidth: 1,
          // pointBorderColor: 'white'
          // backgroundColor: this.gradient
          };

        
      }

      if (filterCount>0) {
        this.filterText = "Note: "+filterCount+" data points (out of "+filterTotalItemsChecked+") were filtered from the chart because they were above the expected reasonable value of "+(this.filter*1).toFixed(0)+" "+(this.filter_prompt == undefined ? "" : this.filter_prompt);
        // console.log("filterText tc2c", this.filterText);
      } else {
        this.filterText = "";
      }

      // now get comparison data
      if (this.compare_collection_id*1>0) {
          // this.showCompare = true;
          // console.log(`/dbcsi/${this.compare_collection_id}/${this.collection_type}/${this.compare_chart_id}`);
          filterCount = 0;
          await API.get("dbcsiAPI", `/dbcsi/${this.compare_collection_id}/${this.collection_type}/${this.compare_chart_id}`)
            .then(response => {
              // console.log("TCC2: I am here3");
              this.maindata = response.data;
              this.newdata = [[], [], []];
              // console.log("compare data", this.maindata.length);

              for (var ii = 0; ii < this.maindata.length; ii++) {
                // console.log("filter,id",this.filter, this.compare_chart_id, this.adjustment);
                
                //fix data (some chartIDs return data as y not y1)
                if (this.maindata[ii].y!=undefined) this.maindata[ii].y1=this.maindata[ii].y;

// we will not filter in the comparison chart .. see (1==1)
                if ( (1==1) || ((this.filter==undefined)||(this.filter=="NaN")||(this.filter*1==0)) || ((this.filter!=undefined)&&(this.filter*1>0)&&(this.maindata[ii].y1*1 < this.filter)) ) {
                  //we are not using a filter or we meet the filter
                
                  if (( (this.compare_chart_id=="CPUAVGPEAK")||(this.compare_chart_id=="IO_MBS_AVGPEAK")||(this.compare_chart_id=="IOPS_AVGPEAK") ||(real_chart_id=="IOPS_AVGPEAK") ||(real_chart_id=="PDB_IOPS")||(real_chart_id=="PDB_CPU_USAGE_PER_S")||(real_chart_id=="PDB_IOMBPS")||(real_chart_id=="cpu_per_s")||(real_chart_id=="cpu_per_s_max")) 
                     && (this.adjustment!=undefined) && (this.adjustment*1!=0) && (this.adjustment*1!=1)) {
                    this.newdata[0].push({
                      x: this.maindata[ii].x,
                      y: this.maindata[ii].y1/(this.adjustment*1)
                    });
                    // we will not filter in the comparison chart .. see (1==1)
                    if ( (1==1) || ((this.filter==undefined)||(this.filter=="NaN")||(this.filter*1==0)) || ((this.filter!=undefined)&&(this.filter*1>0)&&(this.maindata[ii].y2*1 < this.filter)) ) {
                      this.newdata[1].push({
                        x: this.maindata[ii].x,
                        y: this.maindata[ii].y2/(this.adjustment*1)
                      });
                      // console.log("adjusting y2");
                    } else {
                      filterCount++;
                    } 
                    this.newdata[2].push({
                      x: this.maindata[ii].x,
                      y: this.maindata[ii].y3/(this.adjustment*1)
                    });
                    
                  } else {
                    this.newdata[0].push({
                      x: this.maindata[ii].x,
                      y: this.maindata[ii].y1
                    });
                    if ( ((this.filter==undefined)||(this.filter=="NaN")||(this.filter*1==0)) || ((this.filter!=undefined)&&(this.filter*1>0)&&(this.maindata[ii].y2*1 < this.filter)) ) {
                      this.newdata[1].push({
                        x: this.maindata[ii].x,
                        y: this.maindata[ii].y2
                      });
                    } else {
                      filterCount++;
                    }
                    this.newdata[2].push({
                      x: this.maindata[ii].x,
                      y: this.maindata[ii].y3
                    });
                  }
                  
                  //calculate statistics
                  if (this.stacked=="false") {
                    current_val=Math.max(Number(this.maindata[ii].y1),Number(this.maindata[ii].y2));
                  } else {
                    current_val=Number(this.maindata[ii].y1)+Number(this.maindata[ii].y2);
                  }  
                  total_val = total_val + current_val;
                  sorted.push(current_val);
                } else
                {
                  filterCount++;
                }
              }
              

              tries = 0;
              // console.log(this.newdata[0]);
            })
            .catch(error => {
              console.log("TCC2b Error:", error);
            });      
            
            // add to datasets
            this.chartdata.datasets[this.baseDatasets+0] = {
            label: this.compare_label.split(":")[0],
            data: this.newdata[0],
            // borderColor: "#dd0020",
            borderColor: "rgba(140, 39, 245, 0.5)",
            backgroundColor: "rgba(255, 0,0, 0.25)",
            borderWidth: 1,
            pointRadius: 1,
            fill: false,
            hidden: true
          // borderColor: '#FC2525',
          // pointBackgroundColor: 'white',
          // borderWidth: 1,
          // pointBorderColor: 'white'
          // backgroundColor: this.gradient
          };
          this.chartdata.datasets[this.baseDatasets+1] =
          {
            label: this.compare_label.split(":")[1],
            data: this.newdata[1],
            // borderColor: "#3e95cd",
             borderColor: "rgba(35, 33, 36, 0.44)",
            backgroundColor: "rgba(194, 183, 155, 0.25)",
   
            // borderColor: "rgba(0, 231, 255, 1)",
            // backgroundColor: "rgba(0, 231, 255, 0.5)",
            borderWidth: 1,
            pointRadius: 1,            
            fill: false,
            hidden: true
          // borderColor: '#05CBE1',
          // pointBackgroundColor: 'white',
          // pointBorderColor: 'white'
          // borderWidth: 1
          // backgroundColor: this.gradient2

          };



      }

    
      this.loaded = true;
      // console.log("chartID", this.myID, "options", this.options, "chartdata", this.chartdata);
      
    } catch (e) {
      console.error(e);
    }
  },
  methods: {
    async adjustY() {
      if (this.adjustYaxis) {
        this.options.scales.yAxes[0].ticks = this.YaxisTag;
      } else {
        this.options.scales.yAxes[0].ticks = {}; 
            
      }  
      this.loaded=false;
      await nextTick();
      
      // console.log("adjustY:", this.options.scales.yAxes[0], this.adjustYaxis);
      this.loaded=true;
      
    },
    async toggleCompare() {
      if (this.adjustCompare) {
        this.chartdata.datasets[this.baseDatasets+0].hidden = false; 
        this.chartdata.datasets[this.baseDatasets+1].hidden = false;    
      } else {
        this.chartdata.datasets[this.baseDatasets+0].hidden = true; 
        this.chartdata.datasets[this.baseDatasets+1].hidden = true;     
      }  
      this.loaded=false;
      await nextTick();
      
      // console.log("adjustCompare:", this.chartdata.datasets, this.adjustCompare);
      this.loaded=true;
      
    }
    
   }
};
</script>